export const checkOnHttp = (url: string) => {
  const objRE = /(^https?:\/\/)/i;
  
  return objRE.test(url);
};
